import { Component } from '@theme/component';
import { autoApplyDiscountCode } from './auto-apply-coupon.js';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * If the copied text appears to be a discount code, automatically applies it to the cart.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (copySuccessMessage instanceof Element) {
      copySuccessMessage.classList.remove('visually-hidden');
      
      // Hide the success message after 2 seconds
      setTimeout(() => {
        copySuccessMessage.classList.add('visually-hidden');
      }, 2000);
    }

    // Check if this looks like a discount code and auto-apply it
    autoApplyDiscountCode(copyContent);
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
